import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import {
  initGladly,
  getGladlyAppId,
  showGladlyWidget,
  setGladlyUser,
  clearGladlyUser,
  closeGladlyWidget,
} from './utils';

import './gladly-widget.less';
import { inject } from 'mobx-react';

const EXCLUDED_ROUTES = ['/group-sales-test-chat'];

const GladlyWidget = ({ appSession }) => {
  const location = useLocation();

  const [initializedAppId, setInitializedAppId] = useState(null);

  const isExcludedRoute = EXCLUDED_ROUTES.includes(location.pathname);
  // Careers runs on its own Gladly app, so the widget is initialized per route.
  const appId = getGladlyAppId(location.pathname);

  useEffect(() => {
    const initialize = async () => {
      try {
        if (isExcludedRoute) {
          return;
        }

        if (initializedAppId !== appId) {
          await initGladly(location.pathname);
          setInitializedAppId(appId);
          // Only open Gladly widget by default when on /chat page
          if (location.pathname === '/chat') {
            showGladlyWidget();
          }
        }

        if (appSession.isLoggedIn()) {
          await setGladlyUser();
        } else {
          clearGladlyUser();
        }
      } catch (error) {
        console.error('Error initializing Gladly widget:', error);
      }
    };

    initialize();
  }, [appSession.token, isExcludedRoute, appId]);

  useEffect(() => {
    const isOpen = document.querySelector('.gladlyChat_open');
    if (isOpen) {
      closeGladlyWidget();
    }
  }, [location]);

  if (isExcludedRoute) {
    return null;
  }

  return (
    <button id="custom-gladly-chat-button" onClick={showGladlyWidget}>
      <div id="with-no-active-chat">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-chat-fill"
          viewBox="0 0 16 16">
          <path d="M8 15c4.418 0 8-3.134 8-7s-3.582-7-8-7-8 3.134-8 7c0 1.76.743 3.37 1.97 4.6-.097 1.016-.417 2.13-.771 2.966-.079.186.074.394.273.362 2.256-.37 3.597-.938 4.18-1.234A9 9 0 0 0 8 15" />
        </svg>
      </div>
      <div id="with-active-chat">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-chat-dots-fill"
          viewBox="0 0 16 16">
          <path d="M16 8c0 3.866-3.582 7-8 7a9 9 0 0 1-2.347-.306c-.584.296-1.925.864-4.181 1.234-.2.032-.352-.176-.273-.362.354-.836.674-1.95.77-2.966C.744 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7M5 8a1 1 0 1 0-2 0 1 1 0 0 0 2 0m4 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0m3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />
        </svg>
        <div id="with-unread-message"></div>
      </div>
    </button>
  );
};

export default inject('appSession')(GladlyWidget);
